import reducer from './Reducers/Reducers';
import { applyMiddleware, createStore } from 'redux';
import { thunk, ThunkMiddleware } from 'redux-thunk';
const store = createStore(reducer, applyMiddleware(thunk as ThunkMiddleware));

export type RootState = ReturnType<typeof reducer>;
export type AppDispatch = typeof store.dispatch;

export default store;